<template>
<!--  Make sure parent is position: relative -->
    <div class="aup-overlay w-100 h-100" tabindex="-1" ref="overlayContainer" :class="{ 'd-flex justify-content-center align-items-center': !sticky}">
        <slot />
    </div>
</template>
<script>
export default {
    name: "BaseOverlay",
    props: {
        sticky: {
            type: Boolean,
            default: false,
        }
    },
    mounted () {
        this.$refs.overlayContainer.focus();
    }
};
</script>

<style lang="scss">
    .aup-overlay {
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(255, 255, 255, 0.95);
        z-index: 5;
    }
</style>

